import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { DashboardLayout } from "../layouts/DashboardLayout";
import { useSelector } from "react-redux";
import useFetchClinicians from "../hooks/Clinic/useFetchClinician";
import MatchmakingFilters from "../components/matchmaking/MatchmakingFilters";
import { Sparkles, Users, TrendingUp, Brain, Loader2, AlertCircle } from "lucide-react";

export const MatchmakingPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { loading, clinicians, error } = useSelector((state: any) => ({
    loading: state.clinics.status === "loading",
    clinicians: state.clinics.clinicians,
    error: state.clinics.error,
  }));
  
  const { fetchClinicianData } = useFetchClinicians();

  useEffect(() => {
    if (id) {
      fetchClinicianData();
    }
  }, [id, fetchClinicianData]);


  // Modern Error State
  if (error) {
    return (
      <DashboardLayout>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50">
          <div className="flex items-center justify-center min-h-[80vh]">
            <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-12 text-center max-w-md">
              <div className="w-20 h-20 bg-gradient-to-br from-red-400 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <AlertCircle className="h-10 w-10 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                We couldn&apos;t load matchmaking
              </h3>
              <p className="text-gray-600 mb-6">{error}</p>
              <button 
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-2xl hover:from-purple-700 hover:to-blue-700 transition-all duration-300 font-semibold"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50">
        <div className="relative overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-6 sm:pt-8 pb-2">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
              Matchmaking
            </h1>
            <p className="mt-1 text-sm sm:text-base text-gray-600 max-w-2xl">
              Find clinicians in your network by specialty, location, availability, insurance, and more—then review matches in gallery or list view.
            </p>
          </div>
          <MatchmakingFilters />
        </div>

        <div className="relative mt-16 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-t from-purple-100/50 to-transparent"></div>
          <div className="relative h-32"></div>
        </div>
      </div>
    </DashboardLayout>
  );
};